// Angel One API Client — calls Cloud Functions via httpsCallable
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();

function call(name) {
  return httpsCallable(functions, name);
}

const angelOneApi = {
  // Auth
  login: (data) => call('angelOneLogin')(data),
  logout: () => call('angelOneLogout')(),
  refreshToken: () => call('angelOneRefreshToken')(),
  getProfile: () => call('angelOneGetProfile')(),
  checkSession: () => call('angelOneCheckSession')(),

  // Orders
  placeOrder: (data) => call('angelOnePlaceOrder')(data),
  modifyOrder: (data) => call('angelOneModifyOrder')(data),
  cancelOrder: (data) => call('angelOneCancelOrder')(data),
  getOrderBook: () => call('angelOneGetOrderBook')(),
  getTradeBook: () => call('angelOneGetTradeBook')(),

  // Portfolio
  getPositions: () => call('angelOneGetPositions')(),
  getHoldings: () => call('angelOneGetHoldings')(),
  getAllHoldings: () => call('angelOneGetAllHoldings')(),
  getRMS: () => call('angelOneGetRMS')(),
  convertPosition: (data) => call('angelOneConvertPosition')(data),

  // Market Data
  getLTP: (data) => call('angelOneGetLTP')(data),
  getQuote: (data) => call('angelOneGetQuote')(data),
  getCandles: (data) => call('angelOneGetCandles')(data),
  searchScrip: (data) => call('angelOneSearchScrip')(data),

  // GTT
  createGTT: (data) => call('angelOneCreateGTT')(data),
  cancelGTT: (data) => call('angelOneCancelGTT')(data),
  listGTT: (data) => call('angelOneListGTT')(data),

  // Analytics
  getOptionGreeks: (data) => call('angelOneGetOptionGreeks')(data),
  getGainersLosers: (data) => call('angelOneGetGainersLosers')(data),
  getPCR: (data) => call('angelOneGetPCR')(data),

  // Instrument Master
  getInstrumentMaster: () => call('getInstrumentMaster')(),
};

export default angelOneApi;
